export const PAYEE_INVOICE_RECEIVE_SUPPORT_SITE = '#';
